const privateLDAttributeNames = ['email']
const getLDUser = function(userData) {
  return {
    key: userData?.id,
    email: userData?.email,
    custom: {
      type: 'LENDER_USER',
      role: userData?.role?.name,
      lender: userData?.lender?.name,
      lender_name: userData?.lender?.name,
      lender_id: userData?.lender?.id,
    },
    privateLDAttributeNames,
  }
}

const defaultAnonymousUser = {
  key: 'unidentified_init_user',
  name: 'init_user',
  lender_name: 'init_lender',
  email: 'init_user@reggora.com',
  type: 'LENDER_USER',
  privateAttributeNames: privateLDAttributeNames,
}

export { privateLDAttributeNames, defaultAnonymousUser, getLDUser }
